<template>
  <div class='EnbMap'>
    <div class="label">Localização da Loja</div>
    <iframe
    v-show="!load"
    @load="mapLoaded"
    width="200"
    height="500"
    id="gmap_canvas"
    :src="src"
    frameborder="0"
    scrolling="no"
    marginheight="0"
    marginwidth="0">
    </iframe>
    <div v-if="load" class="c-load">
      <component
      :is="Prefes.spinner.tipo"
      :color="Prefes.spinner.cor"
      :size="Prefes.spinner.tipo === 'EnbSyncLoader' ? '12px' : '40px'"
      style="z-index: 999"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { loaders } from '@/components/Spinner'
export default {
  name: 'EnbMap',
  components: { ...loaders },
  data () {
    return {
      load: true
    }
  },
  computed: {
    ...mapGetters(['Empresa', 'Prefes']),
    src () {
      return this.Empresa.maps !== '' ? this.getSrc(this.Empresa.maps) : this.getSrc('<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3741.7081000137046!2d-40.29062452552543!3d-20.312345981163688!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xb817cf17865ee1%3A0x39dd8e608645944!2sSHOPPING%20VIT%C3%93RIA!5e0!3m2!1spt-BR!2sbr!4v1739230041865!5m2!1spt-BR!2sbr" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>')
    }
  },
  methods: {
    getSrc (str) {
      let src = str.substr(str.indexOf('src="') + 5, str.length - str.indexOf('src="'))
      src = src.substr(0, src.indexOf('"'))
      return src
    },
    mapLoaded () {
      this.load = false
    }
  }
}
</script>

<style scoped>
.EnbMap {
  margin-top: 2%;
}

.label {
  padding: 4%;
  font-size: 16px;
}

.c-load {
  width: 250px;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}

</style>
